module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0126.jpg?v=d8e27e00";